(() => {
  if (window.tosInitTrustBadges) {
    window.tosInitTrustBadges();
    return;
  }

  const initialized = new WeakSet();

  function initialize() {
    document.querySelectorAll('.tos-trust-bullets').forEach(list => {
      if (initialized.has(list)) return;
      initialized.add(list);
      const items = Array.from(list.querySelectorAll('strong'));
      let queued = false;
      let forceFit = false;
      let lastWidth = 0;

      function fit() {
        const measurements = items.map(el => {
          const item = el.closest('li');
          const wrap = el.parentElement;
          if (!item || !wrap) return null;
          const icon = item.querySelector('.tos-trust-icon');
          const styles = window.getComputedStyle(item);
          const gap = parseFloat(styles.columnGap || styles.gap) || 0;
          const itemWidth = item.clientWidth;
          if (!itemWidth) return null;
          return {
            el, wrap,
            available: Math.max(28, Math.floor(itemWidth - (icon ? icon.getBoundingClientRect().width : 0) - gap)),
            low: 7, high: itemWidth > 220 ? 16 : 14, best: 7,
          };
        }).filter(Boolean);

        measurements.forEach(({ wrap, available }) => {
          wrap.style.flexBasis = available + 'px';
          wrap.style.maxWidth = available + 'px';
        });

        // Batch writes before reads: one layout pass per round, shared by all labels.
        for (let step = 0; step < 8; step++) {
          measurements.forEach(measurement => {
            measurement.mid = (measurement.low + measurement.high) / 2;
            measurement.el.style.setProperty('--tos-trust-font-size', measurement.mid + 'px');
          });
          measurements.forEach(measurement => {
            if (measurement.el.scrollWidth <= measurement.available + 0.5) {
              measurement.best = measurement.mid;
              measurement.low = measurement.mid;
            } else {
              measurement.high = measurement.mid;
            }
          });
        }
        measurements.forEach(({ el, best }) => {
          el.style.setProperty('--tos-trust-font-size', Math.floor(best * 10) / 10 + 'px');
        });
      }

      function scheduleFit(force = false) {
        forceFit = forceFit || force;
        if (queued) return;
        queued = true;
        requestAnimationFrame(() => {
          queued = false;
          const width = list.clientWidth;
          const shouldFit = width > 0 && (forceFit || width !== lastWidth);
          forceFit = false;
          if (!shouldFit) return;
          lastWidth = width;
          fit();
        });
      }

      if (typeof ResizeObserver !== 'undefined') {
        const observer = new ResizeObserver(() => {
          if (!list.isConnected) { observer.disconnect(); return; }
          scheduleFit();
        });
        observer.observe(list);
      } else {
        window.addEventListener('resize', () => scheduleFit(), { passive: true });
      }
      if (document.fonts?.ready) document.fonts.ready.then(() => scheduleFit(true));
      scheduleFit(true);
    });
  }

  window.tosInitTrustBadges = initialize;
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
